export default __webpack_public_path__ + "static/media/nissan.dddb4886.png";